import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronTriangleRightMedium"><Path d="M9 8.3592C9.00009 7.08476 10.489 6.39103 11.4648 7.21077L15.7988 10.8514C16.5122 11.4508 16.5123 12.5489 15.7988 13.1483L11.4648 16.7889C10.489 17.6085 9.00022 16.9147 9 15.6405V8.3592Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleRightMedium;
